import { api } from '@/global/services/api'

export default {
  name: 'documentHistoryHelper',

  data () {
    return {
      logsData: {},
      logsShowLoader: false
    }
  },

  methods: {
    async fetchHistoryDocuments (documentType, documentsKey) {
      const { id } = this.$route?.params || {}

      if (!id) {
        console.error('Missing traffic regulation id')
        return
      }

      if (typeof documentType !== 'string' || !documentType) {
        console.error('Invalid or missing document type')
        return
      }

      if (typeof documentsKey !== 'string' || !documentsKey) {
        console.error('Invalid or missing documents key')
        return
      }

      this.logsShowLoader = true

      try {
        const { data } = await api('road-maintenance').get(
          `traffic-regulation/${id}/${documentType}/history`
        )

        this.$set(this.logsData, documentsKey, data)
      }
      catch (error) {
        console.error('Error fetching document history:', error)
      }
      finally {
        this.logsShowLoader = false
      }
    },

    async downloadDocument (event) {
      const { id: documentId, name } = event?.data || {}
      const { id: trafficRegulationId } = this.$route?.params || {}

      if (!documentId) {
        console.error('Missing document id')
        return
      }

      if (!trafficRegulationId) {
        console.error('Invalid or missing traffic regulation id')
        return
      }

      const url = new URL(`${window.location.origin}/api/road-maintenance/traffic-regulation/${trafficRegulationId}/document/${documentId}`)
      let objectURL = null

      try {
        const response = await fetch(url.toString(), {
          method: 'POST'
        })

        if (!response.ok) {
          console.error(`Failed to show PDF: HTTP ${response.status} - ${response.statusText}`)
          return
        }

        const arrayBuffer = await response.arrayBuffer()

        // Create a Blob from the response data
        const blob = new Blob([new Uint8Array(arrayBuffer)], {
          type: 'application/pdf'
        })

        // Generate object URL for downloading
        objectURL = URL.createObjectURL(blob)
        const filename = name ? name + '.pdf' : 'pdf_preview.pdf'

        // Trigger download
        const link = document.createElement('a')
        link.href = objectURL
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
      catch (exception) {
        console.error('Error showing pdf:', exception.message || exception)
      }
      finally {
        // Revoke object URL to release memory
        if (objectURL) {
          URL.revokeObjectURL(objectURL)
        }
      }
    },

    async previewDocument (event = {}, documentType, documentName) {
      const { id: trafficRegulationId } = this.$route?.params || {}
      const { html } = event?.formData || {}

      if (!trafficRegulationId) {
        console.error('Invalid or missing traffic regulation id')
        return
      }

      if (!documentType) {
        console.error('Invalid or missing document type')
        return
      }

      if (!html || typeof html !== 'string') {
        console.error('Invalid or missing html')
        return
      }

      const formData = new FormData()
      formData.append('html', html)

      const url = new URL(`${window.location.origin}/api/road-maintenance/traffic-regulation/${trafficRegulationId}/${documentType}/preview`)
      let objectURL = null

      try {
        const response = await fetch(url.toString(), {
          method: 'POST',
          body: formData
        })

        if (!response.ok) {
          console.error(`Failed to show PDF: HTTP ${response.status} - ${response.statusText}`)
          return
        }

        const arrayBuffer = await response.arrayBuffer()

        // Create a Blob from the response data
        const blob = new Blob([new Uint8Array(arrayBuffer)], {
          type: 'application/pdf'
        })

        // Generate object URL for downloading
        objectURL = URL.createObjectURL(blob)
        const filename = documentName ? documentName + '.pdf' : 'pdf_preview.pdf'

        // Trigger download
        const link = document.createElement('a')
        link.href = objectURL
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
      catch (exception) {
        console.error('Error showing pdf:', exception.message || exception)
      }
      finally {
        // Revoke object URL to release memory
        if (objectURL) {
          URL.revokeObjectURL(objectURL)
        }
      }
    }
  }
}
